// Framework
import { Injectable } from '@angular/core';
import { take, finalize } from 'rxjs/operators';
// Providers
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';
import { AppService } from './app.service';

@Injectable()

export class UploadService {
    constructor (
        private storage: AngularFireStorage,
        private afs: AngularFirestore,
        private appSvc: AppService
    ) {}

    // Upload school image to database.
    uploadSchoolImage(file: any, schoolName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            if (file.type.indexOf('png') < 0 && file.type.indexOf('jpg') < 0 && file.type.indexOf('jpeg') < 0) {
                this.appSvc.showAlert('<i class="fas fa-times mr-3"></i>Sorry, the image must be a .png or .jpg file.', 'danger-custom', true, 5000);
                return;
            }
            let fileType = (file && file.type && ((file.type.indexOf("jpg") > -1) || (file.type.indexOf("jpeg") > -1)) ? ".jpg" : (file.type && (file.type.indexOf("png") > -1) ? ".png" : ""));
            const filePath = '--childpilot/' + schoolName + '/logos/'  + this.afs.createId() + fileType;
            const fileRef = this.storage.ref(filePath);
            // Upload image...
            const imgUploadTask = fileRef.put(file);
            imgUploadTask.snapshotChanges()
                .pipe(
                    finalize(() => {
                        fileRef.getDownloadURL()
                            .pipe(
                                take(1)
                            )
                            .subscribe((downloadURL: string) => {
                                resolve(downloadURL);
                            });
                    })
                )
                .subscribe();
        })
    }
}